











































































































































































































































































import {
  ConstraintActionEnum,
  FormSectionFieldConstraint,
  IFormSectionFieldData,
  IFormSectionFieldConstraintData,
  IFormSectionFieldConstraint
} from '@/models';
import { ErrorManager } from '@/models/error';
import { PropertyTabs } from '../FormBuilderPropertiesDrawer.vue';

import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import FormBuilderConstraintConditionsDrawer from '../FormBuilderConstraintConditionsDrawer.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';

export default Vue.extend({
  name: 'FormBuilderConstraintsTab',

  components: {
    ErrorAlert,
    ConfirmationDialog,
    FormBuilderConstraintConditionsDrawer
  },

  props: {
    sectionFields: Array as PropType<IFormSectionFieldData[]>,
    selectedFieldIndex: Number,
    templateId: Number
  },

  data() {
    return {
      PropertyTabs,
      ConstraintActionEnum,

      loading: false,
      errorMessage: '',
      detailErrorMessage: '',

      deleteDialog: false,
      selectedDeleteConstraintIndex: -1,

      drawer: false,

      constraintOptions: [
        { label: 'Required', value: ConstraintActionEnum.Required },
        { label: 'Optional', value: ConstraintActionEnum.Optional },
        { label: 'Disabled', value: ConstraintActionEnum.Disabled }
      ],
      selectedConstraint: {} as IFormSectionFieldConstraintData,

      activePanel: 0
    };
  },

  computed: {
    ...mapGetters({
      getFormFieldById: 'formTemplate/getFormFieldById',
      getFormFieldsOptionByTemplateIdAndOptionId:
        'formTemplate/getFormFieldsOptionByTemplateIdAndOptionId'
    })
  },

  mounted() {
    this.loading = true;
    this.fetchFormFields()
      .catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    ...mapActions({
      fetchFormFields: 'formTemplate/fetchFormFields'
    }),

    openDrawer(constraint: IFormSectionFieldConstraint) {
      this.selectedConstraint = constraint;
      this.drawer = true;
    },

    goToTabWindow(tab: PropertyTabs) {
      this.$emit('goToTabWindow', tab);
    },

    openDeleteDialog(index: number) {
      this.selectedDeleteConstraintIndex = index;
      this.deleteDialog = true;
    },

    closeDeleteDialog() {
      this.selectedDeleteConstraintIndex = -1;
      this.deleteDialog = false;
    },

    removeConstraint() {
      this.sectionFields[this.selectedFieldIndex].constraints.splice(
        this.selectedDeleteConstraintIndex,
        1
      );

      this.closeDeleteDialog();
    },

    async setSelectedContraintOption(type: ConstraintActionEnum) {
      const instance = new FormSectionFieldConstraint({
        action: type,
        conditions: []
      });

      this.sectionFields[this.selectedFieldIndex].constraints.push(instance);

      this.activePanel =
        this.sectionFields[this.selectedFieldIndex].constraints.length - 1;
    },

    clearAllErrors() {
      this.detailErrorMessage = '';
      this.errorMessage = '';
    }
  }
});
